import { Col, Row } from 'react-bootstrap'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';
import constants from '../../../contants';
import './client.css'
const { clients } = constants;

function Client() {
  const { t } = useTranslation();

  var settings = {
    className: "center",
    infinite: true,
    autoplay: true,
    arrows: false,
    centerMode: true,
    centerPadding: "10px",
    speed: 1200,
    responsive: [
      {
        breakpoint: 5000, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1125, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 880, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 500, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 350, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 1.95,
        },
      },
    ],
  };
  return (
    <section className="client-section" aria-labelledby="clients-heading">
      <Row className='justify-content-center'>
        <Col sm="auto">
          <h2 id="clients-heading" className='clients-heading'>{t("ourclients")}</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="text-center px-5 pb-5">
            Our clients include tech startups, SaaS platforms, eCommerce brands, and blockchain innovators who rely on Bringit Go for high-quality software solutions and long-term partnerships.
          </p>
        </Col>
      </Row>
      <Row className='m-2'>
        <Col>
          <Slider {...settings}>
            {clients.map((client, index) => (
              <article className="client-card" key={client.name || index}>
                <div className='d-flex justify-content-center overflow-hidden'>
                  <img className='clientLogo' src={client.logo} alt={`${client.name} logo`} loading="lazy" decoding="async" width={100} height={100} />
                </div>
                <p className='clientName d-flex justify-content-center mt-3'>{client.name}</p>
              </article>
            ))}
          </Slider>
        </Col>
      </Row>
    </section>
  )
}

export default Client
